import {
  authenticatedUser
} from 'shared-assets/lib/sdk/authenticatedUser';
import featureTogglesSdk from 'shared-assets/lib/sdk/featureToggles';
import PracticeSdk from 'shared-assets/lib/sdk/practice';
import getSessionId from 'shared-assets/lib/utils/sessionId';

sessionId = getSessionId();
cacheConfig = PracticeSdk.getCacheConfig();

BetaData = angular.module 'kareo.ui.shared.modules.data',
  ['kareo.ui.shared.modules.data.models', 'kareo.ui.shared.modules.featureSet']


BetaData.factory 'defaultRepositoryFactory',[
  '$http',
  ($http) ->

# @param [string|fn] source URL to call or fn to return promise
# @param [function] transform_data_fn (optional) data transformer function
# @param [boolean] useCacheConfig (optional) send cacheConfig as options for $http.get if true
    (source, transform_data_fn, useCacheConfig) ->
      cached_get = null
      service = {}

      service.get = ->
        if cached_get
          return cached_get

        if typeof source is 'string' # source is a url

          config = {}
          if useCacheConfig
            config = cacheConfig

          source = ((url, config) ->
            ->
              $http.get(url, config).then (response) ->
                response.data)(source, config)

        cached_get = source().then (data) ->
          if transform_data_fn ?= service.transformData
            return transform_data_fn data
          data

      service
]

BetaData.service 'privilegeRepository', [
  'PrivilegesFactory', 'defaultRepositoryFactory', '$q', '$rootScope',
  (PrivilegesFactory, defaultRepositoryFactory, $q, $rootScope) ->
    wrappedFn = () ->
      $q (resolve, reject) ->
        authenticatedUser.getPrivileges()
        .then (response) -> $rootScope.$apply () -> resolve(response),
        (response) -> $rootScope.$apply () -> reject(response)

    defaultRepositoryFactory wrappedFn, PrivilegesFactory.fromData
]

BetaData.service 'userRepository', [
  'UserFactory', 'defaultRepositoryFactory', '$q', '$rootScope',
  (UserFactory, defaultRepositoryFactory, $q, $rootScope) ->
    wrappedFn = () ->
      $q (resolve, reject) ->
        authenticatedUser.getAuthenticatedUser()
        .then (response) -> $rootScope.$apply () -> resolve(response),
        (response) -> $rootScope.$apply () -> reject(response)

    defaultRepositoryFactory wrappedFn
      , UserFactory.fromData
]


BetaData.service 'userAttributeRepository', [
  '$http', 'defaultRepositoryFactory','featureSet', '$q',
  ($http, defaultRepositoryFactory, featureSet, $q) ->
    
    repo = {}

    wrappedFn = () ->
      $q (resolve, reject) ->
        afterLoadingFeatures = (features) ->  
          if features['dark-feature.disable-webapp-user-attributes']
            resolve(null)
          else
            defaultRepositoryFactory('/common-ui/api/User/attribute').get()
            .then(resolve)
            .catch(reject)

        featureSet.load().then(afterLoadingFeatures) 

    repo.get = wrappedFn

    repo.updateTourStatus = (tourName, status) ->
      $http
      .put("/common-ui/api/User/attribute/tour/#{tourName}/status/#{status}")
      .then (response) ->
        response.data

    repo.updateTourStatuses = (tours) ->
      $http
      .put("/common-ui/api/User/attribute/tour", tours)
      .then (response) ->
        response.data

    repo
]


BetaData.service 'recentCharts', [
  'defaultRepositoryFactory',
  (defaultRepositoryFactory) ->
    defaultRepositoryFactory '/common-ui/api/User/recentcharts/'
]


BetaData.service 'practice', [
  'defaultRepositoryFactory',
  (defaultRepositoryFactory) ->
    defaultRepositoryFactory('/common-ui/api/Practice?sessionId=' + encodeURIComponent(sessionId), null, true)
]

BetaData.service 'practiceBillingContact', [
  'defaultRepositoryFactory',
  (defaultRepositoryFactory) ->
    defaultRepositoryFactory '/common-ui/api/Practice/billingContact'
]

BetaData.service 'activeCustomerProducts', [
  'defaultRepositoryFactory',
  (defaultRepositoryFactory) ->
    defaultRepositoryFactory '/common-ui/api/Product/customer/activeProducts'
]


BetaData.service 'featuresWithUserAccessListRepository', [
  'defaultRepositoryFactory', '$q', '$rootScope'
  (defaultRepositoryFactory, $q, $rootScope) ->
    wrappedFn = () ->
      $q (resolve, reject) ->
        featureTogglesSdk.getFeatures()
        # shim for old userAccessList that is not used
        .then (response) -> ({features: response, userAccessList: []})
        .then (response) -> $rootScope.$apply () -> resolve(response),
        (response) -> $rootScope.$apply () -> reject(response)
    defaultRepositoryFactory wrappedFn
]


BetaData.service 'practiceFeaturesRepository', [
  'defaultRepositoryFactory', 'featuresWithUserAccessListRepository',
  (defaultRepositoryFactory, featuresWithUserAccessListRepository) ->
    getData = ->
      handler = (response) ->
        response?.features or []

      featuresWithUserAccessListRepository.get().then(handler, handler)

    defaultRepositoryFactory getData, (feature_list) ->
      features = {}
      for feature in feature_list
        features[feature] = true
      features
]


BetaData.service 'userControllableFeaturesRepository', [
  'defaultRepositoryFactory', 'featuresWithUserAccessListRepository',
  (defaultRepositoryFactory, featuresWithUserAccessListRepository) ->
    getData = ->
      featuresWithUserAccessListRepository.get().then (response) ->
        response?.userAccessList or []

    defaultRepositoryFactory getData, (feature_list) ->
      features = {}
      for feature in feature_list
        features[feature] = true
      features
]


BetaData.service 'practiceAttributeRepository', [
  'defaultRepositoryFactory',
  (defaultRepositoryFactory) ->
    defaultRepositoryFactory '/common-ui/api/Practice/attribute'
]

BetaData.service 'customerSummaryRepository', [
  'defaultRepositoryFactory',
  (defaultRepositoryFactory) ->
    defaultRepositoryFactory '/common-ui/api/customer/customerSummary'
]

BetaData.service 'patients', [
  '$http', 'PatientFactory',
  ($http, PatientFactory) ->
    responseTransformer = (response) ->
      PatientFactory.fromData(response.data.patients)
    PatientsService = {}
    PatientsService.searchFullName = (query) ->
      dates = new RegExp(/^((0?[1-9]|1[0-2])[-\/](0?[1-9]|[12][0-9]|3[01])[-\/]((19|20)\d{2})|(0?[1-9]|1[0-2])(0?[1-9]|[12][0-9]|3[01])((19|20)\d{2}))$|^\d{8}$/)
      numbers = new RegExp(/^[0-9/\\-]+$/);
      if (dates.test(query) and query.length in [8, 9, 10])
         $http.get('/common-ui/api/Patient/?dateOfBirth='+
                  query+'&searchVersion=2')
          .then(responseTransformer)
      else if (not (dates.test(query) or numbers.test(query))) and query.length > 1
         $http.get('/common-ui/api/Patient/?fullName=' +
                  encodeURIComponent query.trim().replace(/\s+/g, ' '))
          .then(responseTransformer)
      else
        return Promise.resolve([])

    PatientsService
]

BetaData.service 'messagingDropdown', [
  '$http',
  ($http) ->
    transform = (data) -> data.newMessageCount
    notificationCountRepo = ->
      $http.get '/messages-ui/api/ConversationList/NotificationCount',
        [{headers: {'Content-Type': 'application/json'}}]
      .then (response) -> response.data
      .then transform

    getNotificationCount: notificationCountRepo
]


BetaData.service 'authenticatedUser', [
  '$q', 'userRepository', 'practiceFeaturesRepository', 'privilegeRepository',
  'userAttributeRepository',
  ($q, userRepository, practiceFeaturesRepository, privilegeRepository,
    userAttributeRepository) ->
    userPrivileges = []
    userRoles = []
    userAttributes = {}
    practiceFeatures = {}


    canEnrollErx: ->
      !!userAttributes.allowedToErxEnroll

    get: ->
      promise = $q.all
        user: userRepository.get()
        attributes: userAttributeRepository.get()
        priv: privilegeRepository.get()
        features: practiceFeaturesRepository.get()

      promise.then (promises) ->
        userPrivileges = promises.priv
        userRoles = promises.user.roles
        userAttributes = promises.attributes
        practiceFeatures = promises.features
        promises.user

    hasPrivilege: (privilege) ->
      !!userPrivileges[privilege]

    hasPrivilegeAccess: (privilege, access) ->
      unless privilege and access
        return false

      # 2 is WRITE which is considered super privilege
      priv = userPrivileges[privilege]
      unless priv and priv.accessType
        return false

      priv.accessType is access or priv.accessType is 2

    hasRole: (targetRole) ->
      for userRole in userRoles
        if targetRole == userRole.name
          return true
      return false

    isMySettingsEnabled: ->
      practiceFeatures.temp_provider_settings

    updateTourStatus: (tourId, statusId) ->
      userAttributeRepository.updateTourStatus tourId, statusId

    updateTourStatuses: (tours) ->
      userAttributeRepository.updateTourStatuses tours
]
